import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { CLIENT_API_URL } from "../../../config";

export interface IDeleteClientMutation {
  client_id: string;
}

export const useDeleteClient = () => {
  return useMutation({
    mutationFn: (props: IDeleteClientMutation) =>
      axios
        .delete(
          `${CLIENT_API_URL}/waves-client-manager-api/v1/clients/${props.client_id}`,
          {}
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
